import useGlobalStartPage from '../globalContent/useGlobalStartPage'

import usePageLink from './usePageLink'

export default function useJoinUsPageLink() {
  const startPage = useGlobalStartPage()
  return usePageLink(startPage?.joinUsPage?.slug)
}
